import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import ResponsiveDrawer from './components/ResponsiveDrawer';
import CircularLoading from './components/CircularLoading';

function matchUser(permit, usertype) {
  const permissions = permit ? permit.split(',') : [];
  if (!permissions.length) {
    return true;
  }
  return permissions.includes(usertype);
}

function canAccessRoute({ role, permit, moduleKey, accessPermissions }) {
  const oldPermitAllowed = matchUser(permit, role);

  if (!oldPermitAllowed) {
    return false;
  }

  if (role === 'admin') {
    return true;
  }

  try {
    if (!accessPermissions || !accessPermissions.permissions || !moduleKey) {
      return oldPermitAllowed;
    }

    const viewPermission = accessPermissions.permissions?.[role]?.[moduleKey]?.view;

    if (viewPermission === true) {
      return true;
    }
    if (viewPermission === false) {
      return false;
    }

    return oldPermitAllowed;
  } catch (error) {
    console.warn('Route permission fallback:', error);
    return oldPermitAllowed;
  }
}

function AccessDenied() {
  const navigate = useNavigate();

  return (
    <ResponsiveDrawer>
      <div style={{ minHeight: '70vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24 }}>
        <div style={{ width: '100%', maxWidth: 520, background: '#fff', borderRadius: 8, padding: 32, textAlign: 'center', boxShadow: '0 2px 10px rgba(0,0,0,0.12)' }}>
          <h2 style={{ margin: '0 0 12px', fontSize: 28 }}>Access Denied</h2>
          <p style={{ margin: '0 0 24px', fontSize: 16, lineHeight: 1.5 }}>
            You do not have permission to view this page. Please contact your administrator.
          </p>
          <button
            type="button"
            onClick={() => navigate('/dashboard')}
            style={{ border: 0, borderRadius: 6, background: '#0d47a1', color: '#fff', cursor: 'pointer', fontWeight: 700, padding: '12px 22px' }}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </ResponsiveDrawer>
  );
}

function ProtectedRoute({ permit, moduleKey, children }) {
  const auth = useSelector((state) => state.auth);
  const settings = useSelector((state) => state.settingsdata.settings);
  const [checkedAuth, setCheckedAuth] = useState(false);

  useEffect(() => {
    if (auth.profile && auth.profile.uid) {
      setCheckedAuth(true);
    }
    if (auth.error && auth.error.msg && !auth.profile) {
      setCheckedAuth(true);
    }
  }, [auth.profile, auth.error]);

  if (!checkedAuth) {
    return <CircularLoading />;
  }

  if (!auth.profile || !auth.profile.uid) {
    return <Navigate to="/login" />;
  }

  const accessPermissions = settings && settings.accessPermissions ? settings.accessPermissions : null;
  const role = auth.profile.usertype;

  return canAccessRoute({
    role,
    permit,
    moduleKey,
    accessPermissions
  }) ? <ResponsiveDrawer>{children}</ResponsiveDrawer> : <AccessDenied />;
}

export default ProtectedRoute;
